/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Close_ConfirmInputs */

const vi_pos_close_confirm = /** @type {(inputs: Pos_Close_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng đơn hàng này?`)
};

/**

* @param {Pos_Close_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_close_confirm = /** @type {((inputs?: Pos_Close_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Close_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_close_confirm(inputs)
});